export const AppRouteNames = {
  // Home
  home: {
    label: "ホーム",
    value: "home",
  },

  // Login
  login: {
    label: "ログイン",
    value: "login",
  },
  logout: {
    label: "ログアウト",
    value: "logout",
  },
  recover: {
    label: "新規登録",
    value: "recover",
  },
  resetPassword: {
    label: "パスワード再設定",
    value: "reset_password",
  },
  register: {
    label: "新規登録",
    value: "register",
  },

  // Information
  information: {
    label: "お知らせ一覧",
    value: "information",
  },
  informationDetail: {
    label: "お知らせの詳細",
    value: "information_detail",
  },

  // company
  companyList: {
    label: "企業管理",
    value: "company_list",
  },
  companyCreate: {
    label: "新規企業登録",
    value: "company_create",
  },
  companyEdit: {
    label: "企業編集",
    value: "company_edit",
  },
  companyDetail: {
    label: "企業詳細",
    value: "company_detail",
  },
  companyImport: {
    label: "企業インポート",
    value: "company_import",
  },
  companyUserCreate: {
    label: "ユーザー追加",
    value: "company_user_create",
  },
  companyUserEdit: {
    label: "ユーザー編集",
    value: "company_user_edit",
  },

  // case
  caseList: {
    label: "案件管理",
    value: "case_list",
  },
  caseCreate: {
    label: "案件管理",
    value: "case_create",
  },
  caseEdit: {
    label: "案件管理",
    value: "case_edit",
  },

  // Talent
  talentList: {
    label: "人材一覧",
    value: "talent_list",
  },
  talentCreate: {
    label: "新規人材登録",
    value: "talent_create",
  },
  talentEdit: {
    label: "人材編集",
    value: "talent_edit",
  },
  talentDetail: {
    label: "人材詳細",
    value: "talent_detail",
  },
  talentImport: {
    label: "人材インポート",
    value: "talent_import",
  },

  // Job
  jobList: {
    label: "求人一覧",
    value: "job_list",
  },
  jobCreate: {
    label: "新規求人登録",
    value: "job_create",
  },
  jobDetail: {
    label: "求人詳細",
    value: "job_detail",
  },
  jobEdit: {
    label: "求人編集",
    value: "job_edit",
  },

  // page not found
  pageNotFound: {
    label: "「ページが見つかりません」の画面",
    value: "page_not_found",
  },
  serverErrorPage: {
    label: "サーバーエラーページ",
    value: "server_error_page",
  },

  // Maintenance
  maintenance: {
    label: "メンテナンス",
    value: "maintenance",
  },

  // user setting
  userSettingDetail: {
    label: "ユーザー設定",
    value: "user_setting_detail",
  },
  userSettingEdit: {
    label: "ユーザー設定編集",
    value: "user_setting_edit",
  },
  userSettingChangeEmail: {
    label: "ユーザー設定のメール更新",
    value: "user_setting_change_email",
  },

  // match
  match: {
    label: "紹介会社情報",
    value: "match",
  },
  matchEdit: {
    label: "紹介会社情報の編集",
    value: "match_edit",
  },

  // exam steps
  examSteps: {
    label: "受験手続",
    value: "exam_steps",
  },
  examStepDetail: {
    label: "受験手続詳細",
    value: "exam_step_detail",
  },

  // learning progress
  learningProgress: {
    label: "学習進捗",
    value: "learning_progress",
  },
  learningProgressDetail: {
    label: "学習進捗詳細",
    value: "learning_progress_detail",
  },
  learningProgressLearnerDetail: {
    label: "学習者進捗詳細",
    value: "learning_progress_learner_detail",
  },
  learningProgressLearnerEdit: {
    label: "学習者進捗編集",
    value: "learning_progress_learner_edit",
  },
  learningProgressReport: {
    label: "学習進捗報告書の作成",
    value: "learning_progress_report",
  },
  learningProgressReportCompany: {
    label: "学習進捗報告書 - 学習者選択",
    value: "learning_progress_report_company",
  },

  // Learner Management
  learnerList: {
    label: "学習者管理",
    value: "learner_list",
  },
  learnerCreate: {
    label: "新規学習者登録",
    value: "learner_create",
  },
  learnerBulkImport: {
    label: "外国人の一括登録",
    value: "learner_bulk_import",
  },
  learnerBulkImportComplete: {
    label: "外国人の一括アカウント発行",
    value: "learner_bulk_import_complete",
  },
  learnerDetail: {
    label: "学習者詳細",
    value: "learner_detail",
  },
  learnerEdit: {
    label: "学習者編集",
    value: "learner_edit",
  },
  learnerPlanList: {
    label: "過去の計画一覧",
    value: "learner_plan_list",
  },

  rsoDetail: {
    label: "登録支援機関情報",
    value: "rso_detail",
  },
  rsoEdit: {
    label: "登録支援機関情報",
    value: "rso_edit",
  },
};
